import React, { lazy, Suspense, useState } from 'react';
import { Helmet } from 'react-helmet';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import CustomerCompanyContext from './context/CustomerCompanyContext';

import LandingPage from './pages/LandingPage/LandingPage';

const Logout = lazy(() => import('./components/Logout/Logout'));
const Login = lazy(() => import('./pages/Login/Login'));
const NotFound = lazy(() => import('./pages/ErrorPages/NotFound/NotFound'));
const DriverFormFill = lazy(() => import('./pages/Drivers/DriverFormFill/DriverFormFill'));
const FilledFormView = lazy(() => import('./pages/Drivers/FilledFormView/FilledFormView'));
const VehicleFormFill = lazy(() => import('./pages/Vehicles/VehicleFormFill/VehicleFormFill'));
const FilledVehicleFormView = lazy(() => import('./pages/Vehicles/FilledVehicleFormView/FilledVehicleFormView'));
const TrainingDashboard = lazy(() => import('./pages/Training/TrainingDashboard/TrainingDashboard'));
const DriverTrainingSession = lazy(() => import('./pages/Training/DriverTrainingSession/DriverTrainingSession'));
const AccessibilityPage = lazy(() => import('./pages/Legal/AccessibilityPage'));
const TermsPage = lazy(() => import('./pages/Legal/TermsPage'));
const PrivacyPage = lazy(() => import('./pages/Legal/PrivacyPage'));
const AccessibilityWidget = lazy(() => import('./components/AccessibilityWidget/AccessibilityWidget'));
const DashboardEntry = lazy(() => import('./DashboardEntry'));

function Layout() {
  const location = useLocation();
  const isPublicIndexablePage = ['/', '/Home', '/accessibility', '/terms', '/privacy'].includes(location.pathname);

  return (
    <>
      <Helmet>
        <title>מערכת דבורה | ניהול צי רכב וקציני בטיחות בתעבורה</title>
        <meta name="description" content="נמאס לכם מטבלאות אקסל? מערכת דבורה מנהלת עבורכם את צי הרכב: בקרת הוצאות דלק וליסינג, התראות על טסטים וביטוחים, תיק רכב דיגיטלי וחיסכון מוכח. תאמו הדגמה קצרה" />
        {!isPublicIndexablePage && <meta name="robots" content="noindex, nofollow" />}
      </Helmet>
  
      <Suspense fallback={<div role="status" aria-live="polite" style={{ minHeight: '100vh', background: '#0f172a' }} />}> 
      <Routes>
        <Route path='/' element={<LandingPage />} /> 
        <Route path='/Home' element={<LandingPage />} /> 
        <Route path='/Login' element={<Login />} />
        <Route path='/form/:formId/:driverId' element={<DriverFormFill />} />
        <Route path='/filled-form/:submissionId' element={<FilledFormView />} />
        <Route path='/vehicle-form/:formId/:vehicleId' element={<VehicleFormFill />} />
        <Route path='/filled-vehicle-form/:submissionId' element={<FilledVehicleFormView />} />
        <Route path='/Training/Dashboard' element={<TrainingDashboard />} />
        <Route path='/training-session/:companyId' element={<DriverTrainingSession />} />
        <Route path='/training-session/:companyId/:trainingId' element={<DriverTrainingSession />} />
        <Route path='/accessibility' element={<AccessibilityPage />} />
        <Route path='/terms' element={<TermsPage />} />
        <Route path='/privacy' element={<PrivacyPage />} />
        <Route path='/Dashboard/*' element={<DashboardEntry />} />
        <Route path='/Logout' element={<Logout />} />
        <Route path='*' element={<NotFound />} />
      </Routes>
      </Suspense>
      <AccessibilityWidget />

   {/*      </div>
      </div> */}
    </>
  );
}

    // Handler to update the current customer in context
/*     const handleCustomerSelect = (customer) => {
      setCurrentCustomer(customer);
    }; */

function App() {
  const [currentCustomer, setCurrentCustomer] = useState(null);
  const [availableCustomers, setAvailableCustomers] = useState([]);
  return (
    <Router>
      <CustomerCompanyContext.Provider value={{
        currentCustomer,
        availableCustomers,
        setCurrentCustomer,
        setAvailableCustomers}}>
        <Layout />
      </CustomerCompanyContext.Provider>
    </Router>
  );
}

export default App;
